import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {EMPTY, from, Observable, throwError} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';

import {TokenStorageService} from "../../local-storage/token-storage.service";
import {AuthService} from '../auth.service';
import {AppMessageService} from "../../app-message/app-message.service";
import {environment} from "../../../../../environments/environment";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private readonly tokenStorageService: TokenStorageService,
    private readonly authService: AuthService,
    private readonly appMessageService: AppMessageService
  ) {
  }

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const accessToken = this.tokenStorageService.getAccessToken();
    if (accessToken) {
      req = req.clone({
        setHeaders: {Authorization: `Bearer ${accessToken}`},
        // params: req.params.set('auth-token', accessToken),
      });
    }

    if (req.url.includes(environment.callActionApiUrl)) { // örnek: url kontrolü
      const basicAuth = btoa(
        `${environment.callActionApiUser}:${environment.callActionApiPassword}`
      );
      req = req.clone({
        setHeaders: {Authorization: `Basic ${basicAuth}`},
      });
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && error.statusText === "Unauthorized" && this.authService.getRefreshToken()) {
          return from(this.authService.refreshToken()).pipe(
            switchMap((data) => {
              this.tokenStorageService.saveAccessToken(data.access_token);
              this.tokenStorageService.saveRefreshToken(data.refresh_token);
              req = req.clone({
                setHeaders: {Authorization: `Bearer ${data.access_token}`},
                params: req.params.set('auth-token', data.access_token!),
              });
              return next.handle(req);
            }),
            catchError((refreshError) => {
              return this.handleErrors(throwError(() => this.authService.logout()), req.url);
            })
          );
        } else if (error.status === 401) {
          this.authService.logout();
          return this.handleErrors(throwError(() => error), req.url);
        } else {
          return this.handleErrors(throwError(() => error), req.url);
        }
      })
    );
  }

  private handleErrors(
    source: Observable<HttpEvent<unknown>>,
    urlPath: string
  ): Observable<HttpEvent<unknown>> {
    return source.pipe(
      catchError((error: any) => {

        if (error?.error && error.error.status === 401 && !urlPath.includes('/auth/')) {
          return this.handle401(error.error, urlPath);
        }

        if (error?.error) {
          this.appMessageService.errorToast(
            error?.error?.message,
            error?.error?.error,
            20000,
            'top-right'
          );
        }

        // rethrow error
        return throwError(() => error?.error);
      })
    );
  }

  private handle401(error: any, url: any) {
    return EMPTY;
  }
}
